var config = {};

config.base_url = "https://i-trade.onrender.com";

export default config;
